"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.promise.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.search.js");
require("core-js/modules/es.parse-int.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _material = require("@mui/material");
var _EnhancedTableHead = _interopRequireDefault(require("./EnhancedTableHead"));
var _EnhancedTableToolbar = _interopRequireDefault(require("./EnhancedTableToolbar"));
var _util = require("./util");
var _iconsMaterial = require("@mui/icons-material");
var _ExportMenu = _interopRequireDefault(require("./ExportMenu"));
var _types = require("./types");
var _luxon = require("luxon");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = void 0 && (void 0).__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var DEFAULT_ROWS_PER_PAGE = 5;
var DEFAULT_PAGE = 0;
function MaterialTable(_a) {
  /*
    This component's state is divided into two parts
      - configured state represents settings the user can configure in the UI
      - internal state represents data not directly set by the user
      - displayed represents already worked through data that is displayed to the user
       This component works in three 'modes'
    In each mode there are different ways of populating the displayed state
    - list mode: the displayed state is populated from the data prop and is processed internally
    - remote mode: the displayed state is populated by calling the remoteData prop and is processed by the database
    - empty mode: the displayed state is populated with an empty array
  */
  var _this = this;
  var _b, _c, _d, _e, _f, _g;
  var data = _a.data,
    headerContent = _a.headerContent,
    isLoading = _a.isLoading,
    onError = _a.onError,
    _onSearch = _a.onSearch,
    options = _a.options,
    title = _a.title,
    defaultSearchString = _a.defaultSearchString;
  var _h = (0, _react.useMemo)(function () {
      var _a, _b, _c, _d;
      // Check if the defaultSearchString is provided, return defaults if not
      if (!defaultSearchString) {
        return {
          defaultColumnSearchTerms: {},
          defaultSearchTerm: '',
          defaultRowsPerPage: null,
          defaultPage: null
        };
      }
      try {
        // Attempt to parse the defaultSearchString
        var parsedDefaultSearch = JSON.parse(defaultSearchString);
        // Handling possibly missing fields in the parsed object
        var columns = parsedDefaultSearch.columns || {};
        var table = parsedDefaultSearch.table || '';
        var rowsPerPage_1 = (_a = parsedDefaultSearch.rowsPerPage) !== null && _a !== void 0 ? _a : null;
        var page_1 = (_b = parsedDefaultSearch.page) !== null && _b !== void 0 ? _b : null;
        // Adjust columns for any special cases, like dates or complex objects
        for (var column in columns) {
          if (columns[column].searchType === 'date' && columns[column].searchValue) {
            var searchValue = columns[column].searchValue;
            // Assuming searchValue is an object with start and end dates for the interval
            columns[column].searchValue = searchValue == null ? null : _luxon.Interval.fromDateTimes(_luxon.DateTime.fromISO((_c = searchValue.start) !== null && _c !== void 0 ? _c : searchValue.s), _luxon.DateTime.fromISO((_d = searchValue.end) !== null && _d !== void 0 ? _d : searchValue.e));
          }
        }
        return {
          defaultColumnSearchTerms: columns,
          defaultSearchTerm: table,
          defaultRowsPerPage: rowsPerPage_1,
          defaultPage: page_1
        };
      } catch (error) {
        // Log and return defaults in case of an error during parsing
        console.error('Failed to parse defaultSearchString:', error);
        return {
          defaultColumnSearchTerms: {},
          defaultSearchTerm: '',
          defaultRowsPerPage: null,
          defaultPage: null
        };
      }
    }, [defaultSearchString]),
    defaultColumnSearchTerms = _h.defaultColumnSearchTerms,
    defaultSearchTerm = _h.defaultSearchTerm,
    defaultRowsPerPage = _h.defaultRowsPerPage,
    defaultPage = _h.defaultPage;
  var _j = (0, _react.useState)(defaultSearchTerm),
    searchTerm = _j[0],
    setSearchTerm = _j[1];
  var _k = (0, _react.useState)(defaultColumnSearchTerms),
    columnSearchTerms = _k[0],
    setColumnSearchTerms = _k[1];
  var _l = (0, _react.useState)(_types.SortDirection.ASC),
    orderDirection = _l[0],
    setOrderDirection = _l[1];
  var _m = (0, _react.useState)(data.columns.findIndex(function (col) {
      return col.disableSort !== true;
    })),
    orderByIdx = _m[0],
    setOrderByIdx = _m[1];
  var _o = (0, _react.useState)(defaultRowsPerPage !== null && defaultRowsPerPage !== void 0 ? defaultRowsPerPage : DEFAULT_ROWS_PER_PAGE),
    rowsPerPage = _o[0],
    setRowsPerPage = _o[1];
  var _p = (0, _react.useState)(false),
    isLoadingRemoteData = _p[0],
    setIsLoadingRemoteData = _p[1];
  var _q = (0, _react.useState)(_types.TableLevelSearchOption.ALL),
    searchType = _q[0],
    setSearchType = _q[1];
  var _r = (0, _react.useState)(defaultPage !== null && defaultPage !== void 0 ? defaultPage : DEFAULT_PAGE),
    page = _r[0],
    setPage = _r[1];
  var _s = (0, _react.useState)({}),
    columnSelectFilterOptions = _s[0],
    setColumnSelectFilterOptions = _s[1];
  var _t = (0, _react.useState)(null),
    exportMenuAnchorEl = _t[0],
    setExportMenuAnchorEl = _t[1];
  var _u = (0, _react.useState)(false),
    isDownloading = _u[0],
    setIsDownloading = _u[1];
  var _v = (0, _react.useState)([]),
    displayedRows = _v[0],
    setDisplayedRows = _v[1];
  var _w = (0, _react.useState)(0),
    displayedTotalCount = _w[0],
    setDisplayedTotalCount = _w[1];
  (0, _react.useEffect)(function () {
    if ((options === null || options === void 0 ? void 0 : options.orderDirection) != null) setOrderDirection(options === null || options === void 0 ? void 0 : options.orderDirection);
    if ((options === null || options === void 0 ? void 0 : options.orderByIdx) != null) setOrderByIdx(options === null || options === void 0 ? void 0 : options.orderByIdx);
    if ((options === null || options === void 0 ? void 0 : options.pageSize) != null && defaultRowsPerPage == null) {
      setRowsPerPage(options === null || options === void 0 ? void 0 : options.pageSize);
    }
    if ((options === null || options === void 0 ? void 0 : options.search) != null) setSearchType(options === null || options === void 0 ? void 0 : options.search);
  }, [options === null || options === void 0 ? void 0 : options.pageSize, options === null || options === void 0 ? void 0 : options.orderByIdx, options === null || options === void 0 ? void 0 : options.orderDirection, options === null || options === void 0 ? void 0 : options.search]); // eslint-disable-line
  (0, _react.useEffect)(function () {
    setColumnSelectFilterOptions((0, _util.findFilterOptionsFromRows)(data));
  }, [data]);
  (0, _react.useEffect)(function () {
    if (data.mode == null || data.mode !== 'list' && data.mode !== 'remote') {
      if (typeof onError === 'function') {
        onError('props.data.mode MUST be set to either "list" or "remote"');
      }
      // Show an empty table
      setDisplayedRows([]);
      setDisplayedTotalCount(0);
    }
  }, [data.mode, onError]);
  (0, _react.useEffect)(function () {
    if (typeof onError === 'function' && data.columns.some(function (col) {
      return col.widthPercent != null;
    }) && data.columns.some(function (col) {
      return col.widthPercent == null;
    })) {
      onError('Either all or no columns may have "widthPercent" set');
    }
  }, [data.columns, onError]);
  (0, _react.useEffect)(function () {
    if (data.mode === 'remote') {
      setIsLoadingRemoteData(true);
      // Create where object
      var where_1 = (0, _util.makeRemoteSearchFromColumns)(data.columns, columnSearchTerms);
      (function () {
        return __awaiter(_this, void 0, void 0, function () {
          var _a, results, totalCount, error_1;
          var _b, _c, _d, _e;
          return __generator(this, function (_f) {
            switch (_f.label) {
              case 0:
                _f.trys.push([0, 2, 3, 4]);
                return [4 /*yield*/, data.fetchRemoteData({
                  page: page,
                  rowsPerPage: rowsPerPage,
                  order: [(_d = (_c = (_b = data.columns[orderByIdx]) === null || _b === void 0 ? void 0 : _b.customSort) === null || _c === void 0 ? void 0 : _c.call(_b, orderDirection)) !== null && _d !== void 0 ? _d : [(_e = data.columns[orderByIdx].remoteField) !== null && _e !== void 0 ? _e : 'id', orderDirection]],
                  where: where_1
                })];
              case 1:
                _a = _f.sent(), results = _a.results, totalCount = _a.totalCount;
                setDisplayedRows(results);
                setDisplayedTotalCount(totalCount);
                setColumnSelectFilterOptions((0, _util.findFilterOptionsFromRows)(data));
                return [3 /*break*/, 4];
              case 2:
                error_1 = _f.sent();
                if (onError) {
                  onError(error_1 !== null && error_1 !== void 0 ? error_1 : 'Failed to load people from database');
                }
                return [3 /*break*/, 4];
              case 3:
                setIsLoadingRemoteData(false);
                return [7 /*endfinally*/];
              case 4:
                return [2 /*return*/];
            }
          });
        });
      })();
    }
  }, [columnSearchTerms, data, onError, orderByIdx, orderDirection, page, rowsPerPage]);
  // Must be called anytime displayedRows should change
  (0, _react.useEffect)(function () {
    if (data.mode === 'list') {
      // For list data, run the provided array through some processing to sort, filter, and paginate it
      var filteredData = (0, _util.getSearchedData)(data.rows, columnSearchTerms, searchTerm, data.columns);
      // Apply sorting
      var sortedData = (0, _util.getOrderedData)(filteredData, data.columns[orderByIdx], orderDirection);
      // Apply pagination
      if (sortedData.length > rowsPerPage) {
        setDisplayedRows(sortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage));
      } else {
        setDisplayedRows(sortedData);
      }
      setDisplayedTotalCount(filteredData.length);
      setColumnSelectFilterOptions((0, _util.findFilterOptionsFromRows)(data));
    }
  }, [data, setDisplayedRows, columnSearchTerms, searchTerm, orderByIdx, orderDirection, rowsPerPage, page]);
  // ** Handlers **
  // Called when user changes sorting index
  var handleRequestSort = function handleRequestSort(_, propertyIdx) {
    var isAsc = orderByIdx === propertyIdx && orderDirection === _types.SortDirection.ASC;
    setOrderDirection(isAsc ? _types.SortDirection.DESC : _types.SortDirection.ASC);
    setOrderByIdx(propertyIdx);
    setPage(0);
    if (_onSearch != null) _onSearch({
      table: searchTerm,
      columns: columnSearchTerms,
      page: 0,
      rowsPerPage: rowsPerPage
    });
  };
  // Called when user clicks next/previous page
  var handleChangePage = function handleChangePage(_, newPage) {
    setPage(newPage);
    if (_onSearch != null) _onSearch({
      table: searchTerm,
      columns: columnSearchTerms,
      page: newPage,
      rowsPerPage: rowsPerPage
    });
  };
  // Called when user changes number of rows per page
  var handleChangeRowsPerPage = function handleChangeRowsPerPage(e) {
    var newRowsPerPage = parseInt(e.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    if (_onSearch != null) _onSearch({
      table: searchTerm,
      columns: columnSearchTerms,
      page: 0,
      rowsPerPage: newRowsPerPage
    });
  };
  // Avoid a layout jump when reaching the last page with empty rows.
  var emptyRows = page > 0 ? rowsPerPage - displayedRows.length : 0;
  return (0, _jsxRuntime.jsx)("div", __assign({
    style: (options === null || options === void 0 ? void 0 : options.flipHorizontalScroll) ? {
      transform: 'rotateX(180deg)',
      overflowX: 'auto'
    } : {}
  }, {
    children: (0, _jsxRuntime.jsx)(_material.TableContainer, __assign({
      component: (_b = options === null || options === void 0 ? void 0 : options.rootComponent) !== null && _b !== void 0 ? _b : _material.Paper,
      sx: options === null || options === void 0 ? void 0 : options.rootSx
    }, {
      children: (0, _jsxRuntime.jsxs)("div", __assign({
        style: (options === null || options === void 0 ? void 0 : options.flipHorizontalScroll) ? {
          transform: 'rotateX(180deg)'
        } : {}
      }, {
        children: [(headerContent != null || title != null || searchType === _types.TableLevelSearchOption.ALL && data.mode === 'list') && (0, _jsxRuntime.jsx)(_EnhancedTableToolbar.default, {
          headerContent: headerContent ? headerContent : (0, _jsxRuntime.jsx)("span", {
            children: title
          }),
          onSearch: function onSearch(searchTerm) {
            if (_onSearch != null) _onSearch({
              table: searchTerm,
              columns: columnSearchTerms,
              page: 0,
              rowsPerPage: rowsPerPage
            });
            setSearchTerm(searchTerm);
            setPage(0);
          },
          showSearch: searchType === _types.TableLevelSearchOption.ALL && data.mode === 'list',
          defaultSearch: searchTerm
        }), (0, _jsxRuntime.jsxs)(_material.Table, __assign({
          "aria-labelledby": "tableTitle",
          size: (options === null || options === void 0 ? void 0 : options.dense) === true ? 'small' : 'medium'
        }, {
          children: [(0, _jsxRuntime.jsx)(_EnhancedTableHead.default, {
            order: orderDirection,
            orderByIdx: orderByIdx,
            onRequestSort: handleRequestSort,
            columns: (_c = data.columns) === null || _c === void 0 ? void 0 : _c.filter(function (column) {
              return column.hidden !== true;
            }),
            mode: data.mode,
            onSearch: function onSearch(columnSearchTerms) {
              for (var columnTitle in columnSearchTerms) {
                var searchValue = columnSearchTerms[columnTitle].searchValue;
                if ((searchValue === null || searchValue === void 0 ? void 0 : searchValue.length) === 0) {
                  delete columnSearchTerms[columnTitle];
                }
              }
              if (_onSearch != null) _onSearch({
                table: searchTerm,
                columns: columnSearchTerms,
                page: 0,
                rowsPerPage: rowsPerPage
              });
              setColumnSearchTerms(columnSearchTerms);
              setPage(0);
            },
            searchType: searchType,
            columnSelectFilterOptions: columnSelectFilterOptions,
            defaultColumnSearchTerms: columnSearchTerms
          }), !(isLoadingRemoteData || isLoading) ? displayedRows.length > 0 ? (0, _jsxRuntime.jsxs)(_material.TableBody, {
            children: [displayedRows.map(function (row, index) {
              return (0, _jsxRuntime.jsx)(_material.TableRow, __assign({
                hover: true
              }, {
                children: data.columns.map(function (column, columnIdx) {
                  if (column.hidden) return null;
                  var displayedContent = null;
                  // Prioritize the render function, if provided
                  if (column.render) {
                    displayedContent = column.render(row);
                  }
                  // Display the column value otherwise
                  else {
                    var value = column.value(row);
                    // Retrieve the value of the cell
                    displayedContent = value == null ? (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {}) : String(value);
                  }
                  // Display boolean values
                  if (displayedContent === true) displayedContent = 'true';else if (displayedContent === false) displayedContent = 'false';
                  return (0, _jsxRuntime.jsx)(_material.TableCell, __assign({
                    padding: "normal",
                    sx: {
                      width: "".concat(column.widthPercent, "%"),
                      minWidth: "".concat(column.minWidth, "px")
                    }
                  }, {
                    children: displayedContent
                  }), columnIdx);
                })
              }), index);
            }), emptyRows > 0 && (0, _jsxRuntime.jsx)(_material.TableRow, __assign({
              style: {
                height: 60 * emptyRows
              }
            }, {
              children: (0, _jsxRuntime.jsx)(_material.TableCell, {
                colSpan: data.columns.length
              })
            }))]
          }) : (0, _jsxRuntime.jsx)("tbody", {
            children: (0, _jsxRuntime.jsx)("tr", {
              children: (0, _jsxRuntime.jsx)("td", {
                children: (0, _jsxRuntime.jsx)(_material.Typography, __assign({
                  style: {
                    display: 'flex',
                    justifyContent: 'left',
                    marginLeft: '20px',
                    marginTop: '20px',
                    width: '100%'
                  }
                }, {
                  children: "Nothing to show."
                }))
              })
            })
          }) : (0, _jsxRuntime.jsx)("tbody", {
            children: (0, _jsxRuntime.jsx)("tr", {
              children: (0, _jsxRuntime.jsx)("td", {
                children: (0, _jsxRuntime.jsx)("div", __assign({
                  style: {
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    paddingTop: '50px'
                  }
                }, {
                  children: (0, _jsxRuntime.jsx)(_material.CircularProgress, {})
                }))
              })
            })
          })]
        })), (0, _jsxRuntime.jsx)("div", __assign({
          style: {
            display: 'flex',
            justifyContent: 'flex-end',
            flexDirection: 'row'
          }
        }, {
          children: (0, _jsxRuntime.jsxs)("div", __assign({
            style: {
              display: 'flex',
              flexDirection: 'row'
            }
          }, {
            children: [(options === null || options === void 0 ? void 0 : options.hideExport) !== true && (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
              children: [(0, _jsxRuntime.jsx)(_material.IconButton, __assign({
                sx: {
                  height: '2.25em',
                  width: '2.25em'
                },
                "aria-controls": "nav-menu",
                "aria-haspopup": "true",
                onClick: function onClick(e) {
                  return setExportMenuAnchorEl(exportMenuAnchorEl == null ? e.currentTarget : null);
                },
                disabled: isDownloading
              }, {
                children: isDownloading ? (0, _jsxRuntime.jsx)(_material.CircularProgress, {
                  style: {
                    color: 'grey'
                  },
                  size: 15
                }) : (0, _jsxRuntime.jsx)(_iconsMaterial.Download, {})
              })), (0, _jsxRuntime.jsx)(_ExportMenu.default, {
                exportTo: function exportTo(type) {
                  return (0, _util.exportTable)(data, type, columnSearchTerms, searchTerm, orderDirection, orderByIdx, title, onError, setIsDownloading);
                },
                anchor: exportMenuAnchorEl,
                onClose: function onClose() {
                  return setExportMenuAnchorEl(null);
                }
              })]
            }), (0, _jsxRuntime.jsx)(_material.TablePagination, {
              rowsPerPageOptions: (_d = options === null || options === void 0 ? void 0 : options.rowsPerPageOptions) !== null && _d !== void 0 ? _d : [5, 10, 20, 100],
              component: "div",
              count: displayedTotalCount,
              rowsPerPage: ((_e = options === null || options === void 0 ? void 0 : options.rowsPerPageOptions) !== null && _e !== void 0 ? _e : [5, 10, 20, 100]).includes(rowsPerPage) ? rowsPerPage : (_g = (_f = options === null || options === void 0 ? void 0 : options.rowsPerPageOptions) === null || _f === void 0 ? void 0 : _f[0]) !== null && _g !== void 0 ? _g : 5,
              page: page,
              onPageChange: handleChangePage,
              onRowsPerPageChange: handleChangeRowsPerPage
            })]
          }))
        }))]
      }))
    }))
  }));
}
var _default = /*#__PURE__*/(0, _react.memo)(MaterialTable);
exports.default = _default;